import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_weekly_rest_days_least_24_consecutive_hours'

export const dataPointDefinition = {
  retracedId: 'number_weekly_rest_days_least_24_consecutive_hours',
  name: 'Number of weekly rest days (at least 24 consecutive hours long) provided by the facility:',
  description:
    "This question refers to the facility's general policy on rest days and refers only to normal contracted working hours. ",
  meta: {
    slcpMeta: {
      key: 'wh-wor-20',
      number: 'WH-WOR-22',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-20', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36500,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
